<template>
    <div class="container">
        <content-header title="Руководство поликлиники"/>
        <div class="inv-divider"></div>
        <div class="flex">
            <img src="../../assets/images/staticPages/Aleksandrova.jpg" alt="Aleksandrova" height="300" width="225"/>
            <div class="left-30px">
                <strong style="font-size: 26px; color: #dd7373;">Александрова Елена Борисовна</strong>
                <div class="inv-divider"></div>
                <br>
                <strong style="font-style: italic; display: block">Главный врач. Доктор медицинских наук</strong>
                <strong style="font-style: italic; display: block">Врач высшей квалификационной категории.</strong>
                <br>
                <p>В 1993 году окончила Российский государственный медицинский университет по специальности «лечебное
                    дело»</p>
                <p>Является членом Европейского общества специалистов по сердечной недостаточности, доцентом кафедры
                    семейной медицины с курсом клинической лабораторной диагностики Федерального государственного
                    бюджетного учреждения «Учебно-научный медицинский центр» Управления делами Президента Российской
                    Федерации</p>
                <p>В 1998г. успешно защитила диссертацию на соискание ученой степени кандидата медицинских наук по
                    специальности «кардиология»</p>
                <p>Имеет три действующих сертификата по специальностям: «терапия», «кардиология», «организация
                    здравоохранения и общественное здоровье»</p>
                <p>1993г. — 1995г. — клиническая ординатура по специальности «терапия» (на кафедре Учебно-научного
                    медицинского центра Управления делами Президента Российской Федерации)</p>
                <p>1995г. — 2007г. — заведующая первым терапевтическим отделением, врач-терапевт ФГУ «Поликлиника № 3»
                    Управления делами Президента Российской Федерации</p>
                <p>2007г. — 2012г. — заместитель главного врача по медицинской части ФГБУ «Поликлиника № 5» Управления
                    делами Президента Российской Федерации</p>
                <p>В феврале 2012г. назначена главным врачом ФГБУ «Поликлиника № 5» Управления делами Президента
                    Российской Федерации</p>
            </div>
        </div>
        <div class="divider"></div>
        <div class="flex">
            <img src="../../assets/images/staticPages/Baranova.jpg" alt="Baranova" height="300" width="225"/>
            <div class="left-30px">
                <strong style="font-size: 26px; color: #dd7373;">Баранова Римма Расимовна</strong>
                <div class="inv-divider"></div>
                <br>
                <strong style="font-style: italic; display: block">Заместитель главного врача по медицинской
                    части</strong>
                <strong style="font-style: italic; display: block">Врач высшей квалификационной категории</strong>
                <br>
                <p>В 1986 году окончила Ярославский государственный медицинский институт, по специальности «внутренние
                    болезни»</p>
                <p>С 1986г. по 1989г. обучалась в клинической ординатуре по специальности «внутренние болезни» при
                    Ярославском государственном медицинской институте</p>
                <p>Имеет три действующих сертификата по специальностям: «терапия», «нефрология», «организация
                    здравоохранения и общественное здоровье»</p>
                <p>В ФГБУ «Поликлиника № 5» Управления делами Президента Российской Федерации работает с января 2008
                    года</p>
                <p>Курирует работу лечебно-профилактических и клинико-диагностических служб</p>
            </div>
        </div>
        <div class="divider"></div>
        <div class="flex">
            <img src="../../assets/images/staticPages/Сагакская-Наталья-Валентиновна-2.png"
                 alt="Сагакская-Наталья-Валентиновна-2" height="300" width="225"/>
            <div class="left-30px">
                <strong style="font-size: 26px; color: #dd7373;">Сагакская Наталья Валентиновна</strong>
                <div class="inv-divider"></div>
                <br>
                <strong style="font-style: italic; display: block">Заместитель главного врача по клинико-экспертной
                    работе</strong>
                <strong style="font-style: italic; display: block">Врач высшей квалификационной категории</strong>
                <br>
                <p>В 1996 году окончила медицинский факультет Мордовского государственного университета имени Н.П.
                    Огарева по специальности «лечебное дело»</p>
                <p>В 1998 году с отличием окончила клиническую ординатуру по специальности «терапия» при медицинском
                    факультете МГУ им. Н.П. Огарева</p>
                <p>Имеет действующие сертификаты по специальности «терапия», «организация здравоохранения и общественное
                    здоровье»</p>
                <p>В ФГБУ «Поликлиника №5» Управления делами Президента Российской Федерации работает с 2013 года.
                    Курирует клинико-экспертную работу. Возглавляет работу лечебно-контрольной подкомиссии по экспертизе
                    временной нетрудоспособности</p>
            </div>
        </div>
        <div class="divider"></div>
        <div class="flex">
            <img src="../../assets/images/staticPages/Kuznetcova.jpg"
                 alt="Kuznetcova" height="300" width="225"/>
            <div class="left-30px">
                <strong style="font-size: 26px; color: #dd7373;">Кузнецова Анна Михайловна</strong>
                <div class="inv-divider"></div>
                <br>
                <strong style="font-style: italic; display: block">Главная медицинская сестра</strong>
                <br>
                <p>В 1995 году окончила Московский медицинский колледж по специальности «сестринское дело»</p>
                <p>Имеет сертификат по специальности «организация сестринского дела»</p>
                <p>В 2013 году окончила Первый Московский государственный медицинский университет имени И.М. Сеченова по
                    специальности «сестринское дело»</p>
                <p>После окончания интернатуры допущена к осуществлению медицинской деятельности по специальности
                    «управление сестринской деятельностью»</p>
                <p>Курирует работу среднего медицинского персонала</p>
            </div>
        </div>
        <div class="inv-divider"></div>
    </div>
</template>

<script>
import ContentHeader from "../../components/layout/ContentHeader";

export default {
    name: "leadership",
    components: {
        ContentHeader
    },
}

</script>

<style lang="scss" scoped>
.container {
    text-align: left;
    font-family: Arial, sans-serif;
    font-size: 13px;
}

strong {
    color: rgb(0, 0, 0);
    font-weight: 700;
    padding: 0;
}

p {
    padding: 1em 0;
    color: #666;
    line-height: 150%;
}

.bold {
    font-weight: bold;
}

.left-1em {
    margin-left: 1em;
}

h3 {
    font-size: 18px;
    margin: 0;
    padding: 0;
    font-weight: normal;
    color: #000;
}

h3:after {
    content: "";
    display: block;
    bottom: 0;
    width: 50px;
    height: 2px;
    background: #00b6cc;
    margin-top: 10px
}

.inv-divider {
    height: 32px;
    display: block;
    width: 100%;
}

.divider {
    height: 1px;
    border-top: 1px solid #ebebeb;
    display: block;
    position: relative;
    top: 1px;
    width: 100%;
    margin: 20px 0;
}

.flex {
    display: flex;
}

.flex.center {
    align-items: center;
}

.box {
    display: inline-block;
    text-align: center;
    width: 225px;
    margin-left: 30px;
}

.box:first-child {
    margin: 0;
}

.link {
    color: #006688;
    border-bottom: 1px dotted #006688;
    text-decoration: none;
    display: block;
    width: fit-content;
    height: fit-content;
}

.left-30px {
    margin-left: 30px;
}

@media screen and (max-width: 768px) {
    .left-30px {
        margin: 30px 0 0;
    }

    .flex {
        flex-wrap: wrap;
    }
}
</style>
